import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

const Light = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(css.light, props.className)}
      ></div>
    );
  },
);

export { Light };
